module.exports = __webpack_public_path__ + "media/images/noticias/viejas/noti_mujer/noti_mujer_1-0277514cea678146a2cac510f7d46f88.jpg";